export const KQL_EDITOR_OPTIONS = {
  baseUrl: 'kql-builder',
  theme: 'vs',
  minimap: {
    enabled: false
  },
  lineNumbers: 'off',
  scrollBeyondLastLine: false,
  automaticLayout: true
};
